// extracted by mini-css-extract-plugin
export var filterButton = "_jr-1";
export var filtersContainer = "_jr-0";